
































































































































































































































































































































/* eslint-disable camelcase */
import Vue from 'vue'
import { getProductContentById } from '@/api/product.ts'
import DescriptionElement from '@/components/DescriptionElement.vue'
import CategoryListBar from '@/components/CategoryListBar.vue'
import VideoModal from '@/components/VideoModal.vue'
import { ICategory, IProductContentData, IProductContentDataIntro, IVariant } from '@/interfaces/product'
import { ICategoryActive } from '@/interfaces/info'
import * as Event from '@/utils/sendEvent'
import { IAddToCartAction } from '@/interfaces/cart'
import { MetaInfo } from 'vue-meta/types/vue-meta'
import moment from 'moment'

export default Vue.extend({
  name: 'Product',
  components: { CategoryListBar, DescriptionElement, VideoModal },
  data () {
    return {
      variantsOptions: [] as Array<any>,
      variants: [] as Array<IVariant>,
      quantity: 1 as number,
      tempQuantity: 1 as number,
      selectedVariantIndex: 0,
      selectedVariant: {
        price_text: '',
        qty: 0,
        discount_info: '',
        discount_badge: undefined as unknown,
        slide_index: 0,
        title: '',
        variant_id: 0,
        del_price_text: '',
        add_text: []
      } as IVariant,
      selectedImageIndex: 0,
      imagesToVariantsIndexMap: [] as number[],
      productData: {
        default_variant_index: 0,
        intro: [],
        intro_pc: [],
        options: [],
        slide_show_media: [],
        title: '',
        title2: '',
        variants: [],
        type: 0,
        meta_title: '',
        meta_keywords: '',
        meta_description: '',
        og_image: ''
      } as IProductContentData | null,
      breadcrumbItems: [] as Array<any>,
      productDescriptionElements: [] as Array<IProductContentDataIntro>,
      isLoading: true,
      isAddingItemToCart: false,
      disablePurchaseNowButton: false,
      disableAddToCartButton: false,
      isShowToast: false,
      hasLoadedBefore: false,
      webAppUnsupportList: [''] // show download App icon
    }
  },
  metaInfo (): MetaInfo {
    return {
      title: this.title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.description
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.keywords
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: this.title
        },
        {
          vmid: 'og:url',
          property: 'og:url',
          content: window.location.href
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: this.image
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.description
        }
      ],
      script: [{
        type: 'application/ld+json',
        json: {
          '@context': 'http://www.schema.org',
          '@type': 'product',
          brand: 'nuPhoto 拍立洗',
          name: this.title,
          image: this.image,
          description: this.description,
          aggregateRating: {
            '@type': 'aggregateRating',
            ratingValue: '5',
            reviewCount: (this.title.length + this.simulateGrowthOfReviews).toString()
          },
          offers: {
            '@type': 'offer',
            availability: 'https://schema.org/InStock',
            price: this.price,
            priceCurrency: 'TWD',
            url: location.href
          }
        }
      }]
    }
  },
  computed: {
    title (): string {
      return this.productData?.meta_title || ''
    },
    productId () : string {
      return this.$route.params.productId
    },
    categoryActive (): ICategoryActive {
      return this.$store.getters['info/active']
    },
    keywords (): string {
      return this.productData?.meta_keywords || ''
    },
    description (): string {
      return this.productData?.meta_description || ''
    },
    image (): string {
      const {
        og_image: ogImage,
        slide_show_media: slideShowMedia = []
      } = this.productData || {}
      return ogImage || slideShowMedia[0]?.url || ''
    },
    simulateGrowthOfReviews (): number {
      const startDay = moment('2021-01-01')
      const diff = moment().diff(startDay, 'days')
      return Math.ceil(50 + (diff * 0.5))
    },
    price () : number {
      const priceText = this.selectedVariant.price_text || '0'
      const numberPattern = /\d+/g
      const result = priceText.match(numberPattern)
      if (result !== null) { return parseInt(result[0]) } else return 0
    },
    redirectProductUrl (): string {
      const { productId } = this.$route.params
      // @TODO range
      if (+productId >= 100 && +productId <= 500) {
        return `/product${productId}`
      }
      return ''
    },
    webAppUnsupported () : boolean {
      const { productId } = this.$route.params
      return this.webAppUnsupportList.includes(productId)
    }
  },
  watch: {
    productId () {
      this.loadProductData()
    },
    categoryActive (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.initializeBreadcrumbItems()
      }
    }
  },
  created () {
    this.loadProductData()

    /* Button type:
    if (productData.type !== 0 & qty > 0) { // Eco product
      (Add to Cart) & (Buy Now)
    } else if (productData.type === 0 & productId not in 100~500 & webapp not support) { // Image Product but webapp not support
      show app download link
    } else if (productData.type === 0 & productId not in 100~500) { // Image Product with Native editor (webapp support)
      (Add to Cart) & (Buy Now) -> Both link to Web App
    } else if (productId not in 100~500) { // Image Product with Webview editor
      (goMake)
    }
    */
  },
  methods: {
    initializeBreadcrumbItems () {
      this.breadcrumbItems = []
      const active = this.$store.getters['info/active'] as ICategoryActive
      const categoryList = this.$store.getters['info/categoryList'] as ICategory[]
      for (const category of categoryList) {
        if (category.category_id.toString() === active.activeCategory) {
          this.breadcrumbItems.push({
            text: category.name,
            to: `/?category=${category.category_id}`
          })

          if (active.activeSubCategory !== null) {
            for (const subCategory of category.category_list_name) {
              if (subCategory.category_id.toString() === active.activeSubCategory) {
                this.breadcrumbItems.push({
                  text: subCategory.name,
                  to: `/?parent=${category.category_id}&category=${subCategory.category_id}`
                })
                break
              }
            }
          }
          break
        }
      }
      if (this.breadcrumbItems.length === 0) {
        this.breadcrumbItems.push({ text: '所有產品', to: '/' })
      }
      if (this.productData && this.productData.title !== '') {
        this.breadcrumbItems.push(this.productData.title)
      }
    },
    async loadProductData () {
      this.$store.commit('SET_FOOTER', false)
      if (this.hasLoadedBefore) {
        // Reset component's data
        Object.assign(this.$data, (this.$options as any).data())
      }

      this.initializeBreadcrumbItems()

      try {
        const productId = parseInt(this.$route.params.productId)
        const country = this.$store.getters.country ? this.$store.getters.country.length === 2 ? this.$store.getters.country : 'TW' : 'TW'
        const requestBody = {
          product_id: productId,
          country
        }

        const { data } = await getProductContentById(requestBody)
        const payload = data.data
        if (payload) {
          this.isLoading = false
          this.productData = payload
          this.breadcrumbItems.push(this.productData.title)
          this.variants = payload.variants
          this.selectedVariantIndex = payload.default_variant_index
          this.selectedImageIndex = payload.default_variant_index
          this.getVariantsOptionsAndImagesMap()
          this.setVariantContent()
          const intro = payload.intro_pc && payload.intro_pc.length > 0 ? payload.intro_pc : payload.intro
          if (intro) {
            intro.forEach(content => {
              this.productDescriptionElements.push(content)
            })
          }

          Event.viewContent(this.productId, payload.title)
          this.$store.commit('SET_FOOTER', true)
          this.hasLoadedBefore = true
        } else {
          throw new Error('發生網路上的錯誤，無法讀取資料')
        }
      } catch (error) {
        this.$router.push({ name: 'Home' })
      }
    },
    getVariantsOptionsAndImagesMap () {
      for (const [index, variant] of this.variants.entries()) {
        this.variantsOptions.push({ text: variant.title, value: index })
        if (this.imagesToVariantsIndexMap[variant.slide_index] === undefined) {
          this.imagesToVariantsIndexMap[variant.slide_index] = index
        }
      }
    },
    setVariantContent () {
      if (this.isLoading || this.variants.length === 0) return
      this.selectedVariant = this.variants[this.selectedVariantIndex]
      this.$nextTick(() => {
        this.onImageClicked(this.selectedVariant.slide_index)
      })
    },
    onImageClicked (index: number, updateVariant = false) {
      if (index < 0) return
      this.selectedImageIndex = index
      if (updateVariant) {
        if (this.productData && this.imagesToVariantsIndexMap[index] !== undefined) {
          this.selectedVariantIndex = this.imagesToVariantsIndexMap[index]
          this.selectedVariant = this.variants[this.selectedVariantIndex]
        }
      }

      const productCarouselElement = this.$refs.productCarousel as any
      if (productCarouselElement) {
        productCarouselElement.setSlide(index)
      }
    },
    onDecreaseAmountClicked () {
      if (this.quantity > 0) {
        this.quantity -= 1
      }
    },
    onIncreaseAmountClicked () {
      if (this.quantity < this.selectedVariant.qty) {
        this.quantity += 1
      }
    },
    onQuanityChanged () {
      if (this.quantity <= 0) { this.quantity = this.tempQuantity }
      if (this.quantity > this.selectedVariant.qty) {
        this.quantity = 1
        this.$bvModal.msgBoxOk('數量超過商品剩餘數量', {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      }
    },
    async handleAddToCart () {
      console.log('Add to cart', this.selectedVariant)
      if (!this.$store.getters.isLogin) {
        this.$router.push({ name: 'Login', query: { redirect: this.$route.path } })
        return
      }
      this.isAddingItemToCart = true

      try {
        const requestBody = {
          token: this.$store.getters.token,
          variant_id: this.selectedVariant.variant_id,
          qty: this.quantity,
          title: this.selectedVariant.title
        } as IAddToCartAction

        const response = await this.$store.dispatch('ADD_TO_CART', requestBody)
        if (response.flag === 0) {
          this.popToast()
          return Promise.resolve()
        } else if (response.flag === 2) {
          this.$bvModal.msgBoxOk('您已在其他地方登入，請重新登入。', {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          }).then(() => {
            if (this.$route.query.webview !== '1') {
              this.$router.push({ name: 'Login', query: { redirect: this.$route.path } })
            }
          })
          return Promise.reject(new Error('您已在其他地方登入，請重新登入。'))
        }
      } catch (error) {
        console.error(error)
        this.$bvModal.msgBoxOk(`載入資料失敗，${error.message}`, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
        return Promise.reject(error)
      } finally {
        this.isAddingItemToCart = false
        this.disablePurchaseNowButton = false
        this.disableAddToCartButton = false
      }
    },
    popToast () {
      this.isShowToast = true
      setTimeout(() => { this.isShowToast = false }, 2000)
    },
    async onPurchaseNowClicked () {
      this.disablePurchaseNowButton = true
      this.handleAddToCart()
        .then(() => {
          setTimeout(() => { this.$router.push({ name: 'Cart' }).catch() }, 1000)
        })
        .catch(error => error)
    },
    onAddToCartClicked () {
      this.disableAddToCartButton = true
      this.handleAddToCart()
    }
  }
}
)
